import React from 'react';
import {
  ModalForm, Phone, Intl, FormActionsBtns,
} from 'components';
import {
  composeValidators, validPhone, validPhoneCountry, required,
} from 'config/InputErrors';

export default ( {
  visible, onClose, onSubmit, isLoading,
} ) => (
  <ModalForm
    title="enterSenderPhone"
    open={visible}
    onClose={onClose}
    size="md"
    isLoading={isLoading}
    onSubmit={onSubmit}
    footer={( <FormActionsBtns saveLabel="save" onClickCancel={onClose} /> )}
    body={() => (
      <>
        <p className="text-center text-gray">
          <Intl id="warningPhone" />
        </p>
        <Phone
          field="phone"
          label="senderPhone"
          labelClass="required"
          placeholder="placeholderPhone"
          labelOnFocus="registerSenderPhoneLabel"
          validate={composeValidators( required, validPhone, validPhoneCountry )}
        />
      </>
    )}
  />
);
